module.exports = __webpack_public_path__ + "img/64.3f36f60d.jpg";